import { useEffect, useState } from "react"
import { SiteHeader } from "../components/site-header"
import { apiGet, type SessionState } from "../lib/api"

export function LoginPage() {
  const params =
    typeof window === "undefined"
      ? new URLSearchParams()
      : new URLSearchParams(window.location.search)
  const provider = params.get("provider")
  const nextPath = safeAppNext(params.get("next"))
  const [sessionChecked, setSessionChecked] = useState(false)

  useEffect(() => {
    let active = true

    apiGet<SessionState>("/api/me")
      .then((session) => {
        if (!active) return
        if (session.authenticated) {
          window.location.replace(nextPath ?? "/app")
          return
        }
        setSessionChecked(true)
      })
      .catch(() => {
        if (active) setSessionChecked(true)
      })

    return () => {
      active = false
    }
  }, [nextPath])

  return (
    <div className="site-frame">
      <SiteHeader />
      <main className="simple-page">
        <div className="eyebrow">Account access</div>
        <h1>Log in or create your team</h1>
        <section className="login-card">
          {!sessionChecked ? (
            <p>Checking your session.</p>
          ) : (
            <>
              <p>
                Start your workspace, connect your accounts, and choose how Adgiro should manage
                campaign activity.
              </p>
              <div className="provider-buttons">
                <a href={googleLoginPath(nextPath)} className="button">
                  Continue with Google
                </a>
                <a href="/auth/login/meta" className="button button--ghost">
                  Explore account setup
                </a>
              </div>
              {provider ? (
                <div className="login-note">Selected account source: {provider}</div>
              ) : null}
            </>
          )}
        </section>
      </main>
    </div>
  )
}

function safeAppNext(value: string | null): string | undefined {
  if (value?.startsWith("/app") && !value.startsWith("//")) {
    return value
  }

  return undefined
}

function googleLoginPath(nextPath: string | undefined): string {
  if (!nextPath) return "/auth/login/google"

  const params = new URLSearchParams({ next: nextPath })
  return `/auth/login/google?${params.toString()}`
}
